import type { MessageDescriptor } from 'react-intl';

export enum CardType {
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  UNSHIPPED_LAST_7_DAYS = 'UNSHIPPED_LAST_7_DAYS',
  SHIPPED_TODAY = 'SHIPPED_TODAY',
  PENDING_RETURNS = 'PENDING_RETURNS',
  YESTERDAY_UNSHIPPED = 'YESTERDAY_UNSHIPPED',
  ON_HOLD = 'ON_HOLD',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  REJECTED_FULFILLMENT = 'REJECTED_FULFILLMENT',
  AGING_ORDERS_7_TO_30_DAYS = 'AGING_ORDERS_7_TO_30_DAYS',
}

export type CardConfig = {
  icon: string;
  labelMessage: MessageDescriptor;
  viewLinkMessage: MessageDescriptor;
  route: string;
  filterSet?: {
    dateTimeFilters?: Array<{
      id?: string;
      filterById: string;
      type: string;
      filterValue: string;
      criterionOperatorValue: string;
      criterionArgumentValue?: string | { startRangeDate: string; endRangeDate: string };
    }>;
  };
  shipmentFilters?: Array<{
    filterById: string;
    type: string;
    filterValue: string;
    criterionOperatorValue: string;
    criterionArgumentValue?: unknown;
  }>;
};

export type CardData = {
  value: number | null;
  isLoading: boolean;
};

export type CardDataProvider = (params: {
  statusCountMap: Record<string, number> | null;
  returnsCountMap: { outstanding: number } | null;
  sellerTimeZone: string;
}) => CardData;
